import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getStoredData } from '../../JsonFiles/fetchData';
import SideIntro from "../../components/SideIntro/SideIntro";
// Import all necessary components
import IntroTemplate from '../../components/IntroTemplate/IntroTemplate'; // Update the path based on your project structure
import RedirectToPage from '../../components/RedirectToPage/RedirectToPage'; // Update the path
import ProjectCardRow from '../../components/ProjectCardRow/ProjectCardRow';
import ViewSlider from '../../components/ViewSlider/ViewSlider';

const Projects = () => {
  const data = getStoredData()?.["13"] ?? {};
  const [products, setProducts] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    // Fetch products
    axios
      .get('https://shahbad-enterprises-backend.vercel.app/products')
      .then(response => setProducts(response.data))
      .catch(error => console.error('Error fetching products:', error));

      axios
      .get('https://shahbad-enterprises-backend.vercel.app/projects')
      .then(response => setProjects(response.data))
      .catch(error => console.error('Error fetching products:', error));
  }, []);

  return (
    <div>
      <IntroTemplate logo={data.logo} title={data.title} image={data.image} />
      <SideIntro title={data.SideTitle} details={data.SideDetails} content={data.SideContent}/>
      <ProjectCardRow data={projects} />
      <ViewSlider
        title={data.HomeBlogTitle}
        link={data.HomeBlogLink}
        text={data.HomeBlogText}
        items={products}
      />
      <RedirectToPage
        link={data.RedirectLink} 
        title={data.RedirectTitle} 
        image={data.RedirectImage} 
        details={data.RedirectDetails} 
        ButtonText={data.RedirectButtonText}
      />
    </div>
  );
};

export default Projects;